export const iconFontAwesomeMedicalHealthTruckMedical = (
	<i className="fa-solid fa-truck-medical"></i>
);
